import UploadIcon from '@svg/upload.svg';
import WarningIcon from '@svg/warning.svg';
import PropTypes from 'prop-types';
import { useState } from 'react';

import styles from './FileUpload.module.scss';

export default function FileUpload({
  maxSizeInMb,
  onChange,
  disabled,
  required,
  helpText,
  multiple,
  accept,
  label,
  value,
  name,
  id,
}) {
  const [error, setError] = useState(false);

  function handleInput(e) {
    // 1,048,576 in Bytes is 1 MB
    if (maxSizeInMb && e.target.files[0].size > maxSizeInMb * 1048576) {
      setError('Het is bestand is te groot, probeer het bestand te verkleinen');
      return;
    }

    setError(false);
    onChange(e);
  }

  return (
    <div className={styles.container}>
      <input
        className={styles.input}
        onChange={handleInput}
        required={required}
        disabled={disabled}
        multiple={multiple}
        accept={accept}
        type="file"
        name={name}
        id={id}
      />

      <label htmlFor={id} className={styles.label}>
        <UploadIcon className={styles.icon} />
        {label}
      </label>

      {!!error && (
        <p className={styles.error}>
          <WarningIcon className={styles.errorIcon} />
          {error}
        </p>
      )}

      {!error && (
        <p className={styles.fileName}>
          {value ? value.name : 'Geen bestand geselecteerd'}
        </p>
      )}

      <p
        className={styles.helpText}
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML={{ __html: helpText }}
      />
    </div>
  );
}

FileUpload.propTypes = {
  onChange: PropTypes.func.isRequired,
  label: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
  helpText: PropTypes.string,
  maxSizeInMb: PropTypes.number,
  accept: PropTypes.string,
  disabled: PropTypes.bool,
  multiple: PropTypes.bool,
  required: PropTypes.bool,
  // eslint-disable-next-line react/forbid-prop-types
  value: PropTypes.object,
};
